import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import dataReducer from './data'
import searchReducer from './search'

const reducers = () => {
    return combineReducers({
        data: dataReducer,
        search: searchReducer,
        routing: routerReducer
    })
}

export default reducers